export default __webpack_public_path__ + "static/media/bg2.ad5c55d9.jpg";